import { useContext, useEffect, useRef, useState } from "react";
import "./LayoutTool.css";

import { Empty } from "antd";

//FontAwesome Imports
import { faBorderAll, faCubes, faGear, faPen, faTrashCan, faVectorSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ColorPicker from "../../../../shared/components/ColorPicker/ColorPicker";
import { Store } from "../../../../store";
import { easeToValuesRAF } from "../../drawUtils";
import ToolTip from "../../../../shared/components/ToolTip/ToolTip";

const LayoutTool = ({ setShowShelf, setDeleteElement, elementType, setShowElementConfigPanel }) => {
  const { state, dispatch } = useContext(Store);
  const { elements, warehouse, layoutEditor } = state;
  const [layoutElements, setLayoutElements] = useState(null);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const elementRef = useRef(null);
  const colorPickerRef = useRef(null);
  const [animations, setAnimations] = useState([]);

  const scrollToElement = (element) => {
    const { panOffset, zoom } = state.layoutEditor;
    // debugger;
    let elementCenter = {
      x: (element.x1 + element.x2) / 2,
      y: (element.y1 + element.y2) / 2,
    };

    const targetPanOffset = {
      x: -elementCenter.x * zoom + window.innerWidth / 2,
      y: -elementCenter.y * zoom + window.innerHeight / 2,
    };

    const cancelAnimation = easeToValuesRAF({
      fromValues: state.layoutEditor.panOffset,
      toValues: { x: targetPanOffset.x, y: targetPanOffset.y },
      duration: 1000,
      onStep: (values) => {
        // console.log("animation values -> ", values);
        dispatch({
          type: "SET_PAN_OFFSET",
          payload: values,
        });
      },
    });
    setAnimations([...animations, { cancel: cancelAnimation }]);
  };

  useEffect(() => {
    return () => {
      animations.forEach((animation) => {
        animation.cancel();
      });
    };
  }, []);

  useEffect(() => {
    const filteredElements = elements.filter((element) => element?.objectType === elementType);
    setLayoutElements(filteredElements);
  }, [elementType, elements]);

  const onSetSelectedElement = (element) => {
    // const rect = elementRef.current.getBoundingClientRect();
    dispatch({ type: "SET_SELECTED_ELEMENT", payload: element });
    dispatch({ type: "RE_SET_ELEMENTS", payload: element.bins || [] });
    scrollToElement(element);
    showColorPicker && setShowColorPicker(false);
  };

  const onClickingEditElement = (element) => {
    onSetSelectedElement(element);
    setShowElementConfigPanel(true);
  };

  const onShowColorPicker = (element) => {
    setShowColorPicker(true);
    //setSelectedColor(element?.color);
    onSetSelectedElement(element);
  };

  const onColorChange = (color) => {
    const selectedElement = layoutEditor.selectedElement;
    if (!color) return;
    if (!selectedElement) return;
    if (selectedElement.color !== color) {
      const updateElement = {
        ...selectedElement,
        color: color,
      };
      dispatch({ type: "UPDATE_ELEMENT", payload: updateElement });
    }
  };

  const handleShelfToggeler = (element = null) => {
    if (element) {
      dispatch({ type: "SET_SELECTED_ELEMENT", payload: element });
    }
    setShowShelf(true);
  };

  const removeElement = (elementToRemove) => {
    setDeleteElement(elementToRemove);
  };

  return (
    <div className="layout-tool-wrapper">
      <div className="layout-tool-container">
        {layoutElements?.length ? (
          layoutElements?.map((element) => {
            return (
              <div key={element.id}>
                <div
                  className={`tool ${state?.layoutEditor?.selectedElement?.id === element?.id ? "active-tool" : ""}`}
                  onClick={() => onSetSelectedElement(element)}
                  ref={elementRef}
                >
                  <div className="tool-info">
                    {/* Element change status Indication */}
                    <div className="element-status-indication-wrapper">
                      <ToolTip title="Unsaved" placement="top">
                        {element?.hasElementChanges && <div className="element-status-indicator"></div>}
                      </ToolTip>
                    </div>

                    <FontAwesomeIcon
                      icon={element?.objectType === "rack" ? faCubes : element?.objectType === "wall" ? faBorderAll : faVectorSquare}
                      className="tool-icon element-icon text-light"
                    />
                    <h4 className="tool-title">{element?.name}</h4>
                  </div>
                  <div className="tool-actions">
                    {/* <div className="color-indicator tool-icon" title="Change Color" style={{ backgroundColor: element?.color, width: "14px", height: "14px", borderRadius: "3px" }} onClick={() => onShowColorPicker(element)}></div> */}

                    {/* <FontAwesomeIcon icon={faGear} className="tool-icon" title="Configure" onClick={() => handleShelfToggeler(element)} /> */}
                    <FontAwesomeIcon icon={faPen} className="tool-icon tool-edit" title="Configure" onClick={() => onClickingEditElement(element)} />

                    <FontAwesomeIcon icon={faTrashCan} title="Delete" className="tool-icon element-delete tool-delete" onClick={() => removeElement(element)} />
                  </div>
                </div>
                {element?.id === state?.layoutEditor?.selectedElement?.id && showColorPicker && (
                  <div style={{ position: "absolute" }} ref={colorPickerRef}>
                    <ColorPicker onColorChange={onColorChange} color={element?.color} setShowColorPicker={setShowColorPicker} />
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
    </div>
  );
};

export default LayoutTool;
